import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import stcLogo from '../assets/stc-logo-300x316.png';

const { Title, Text } = Typography;

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        document.title = "Admin | Login | Save the Children en Perú";
        const params = new URLSearchParams(location.search);
        if (params.get('expired') === 'true') {
            message.warning('Su sesión ha expirado por inactividad');
        }
    }, [location]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const success = await login(values.username, values.password);
            if (success) {
                message.success('¡Bienvenido de nuevo!');
                navigate('/');
            } else {
                message.error('Credenciales inválidas');
            }
        } catch (error) {
            message.error(error.response?.data?.data?.message || 'Error al iniciar sesión. Inténtalo de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: '#0a0a0a' // Very dark grey/black background
        }}>
            <Card style={{
                width: 400,
                boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                borderRadius: 12,
                border: 'none'
            }}>
                <div style={{ textAlign: 'center', marginBottom: 30 }}>
                    <img 
                        src={stcLogo} 
                        alt="Save The Children" 
                        style={{ width: 96, marginBottom: 20 }} 
                    />
                    <Title level={3} style={{ margin: 0, color: '#333' }}>Portal Administración</Title>
                    <Text type="secondary">Inicia sesión en tu cuenta</Text>
                </div>

                <Form
                    name="normal_login"
                    className="login-form"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    size="large"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: '¡Por favor ingresa tu usuario!' }]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Usuario" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: '¡Por favor ingresa tu contraseña!' }]}
                    >
                        <Input
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Contraseña"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox>Recuérdame</Checkbox>
                        </Form.Item>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button" block loading={loading} style={{ background: '#DA291C', borderColor: '#DA291C' }}>
                            Iniciar Sesión
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
